import { type Draft } from 'immer';

import { type FormContainerModelField } from '@blaze-shared/elements-domain';
import { type DatasetRow } from '@blaze-shared/schema-domain';

export function fillCustomFields(draft: Draft<DatasetRow>, customFields: string[]): void {
  for (const field of customFields) {
    // fill in custom fields
    draft[field] = draft[field] ?? null;
  }
}

export function getFormCustomFields(
  model: FormContainerModelField[] | undefined,
): string[] | undefined {
  return model?.filter((f) => f.isCustom).map((f) => f.field);
}
